const PROJECT_ID = '4505907633782784';

export {PROJECT_ID};
